mutation RestoreDocumentsMutation($ids: [ID!]!) {
  restoreDocuments(ids: $ids) {
    id
  }
}
